import styles from '../styles.module.scss'

const ProductDetails = ({ product, rate, startDate, vehicles }) => (
    <div className={styles.productDetails}>
        <span className="font-weight-bold">{product.displayValue}</span>
        <span className="mt-1">
            <span className={styles.lineDescription}>
                <T>dashboard.subscriptions.products.label.plan.name</T>:{' '}
            </span>
            <span>{rate.rateName}</span>
        </span>
        <span className="mt-1">
            <span className={styles.lineDescription}>
                <T>dashboard.subscriptions.products.label.start</T>:{' '}
            </span>
            <span>{startDate.displayValue}</span>
        </span>

        <span className="mt-1">
            <span className={styles.lineDescription}>
                <T>dashboard.subscriptions.products.label.vehicles</T>:{' '}
            </span>
            <span>
                {vehicles &&
                    vehicles.map((v, i) => (
                        <span key={i}>
                            {v.tag}
                            {i < vehicles.length - 1 ? ', ' : ''}
                        </span>
                    ))}
            </span>
        </span>
    </div>
)

export default ProductDetails
